import { Link } from "react-router-dom";
import styled from "styled-components";

export const EventPopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30rem;
  min-height: 40rem;
  gap: 2rem;
`;

export const ActionLink = styled(Link)`
  padding: 4px 15px;
`;
